import { Settings, X } from "lucide-react"
import { useNavigate } from "react-router-dom"

import { getColorSet } from "@/theme/color"
import { useUserStore } from "@/state/user-store"
import { useSessionContext } from "@/state/session-context"
import { getUserDisplayName } from "../../../../shared-src/user"

interface ChannelsHeaderProps {
	onClose: () => void
}

function ChannelsHeader(props: ChannelsHeaderProps) {
	const navigate = useNavigate()

	const user = useUserStore(state => state.user)
	//	ha-203: when the logged-in admin/dev is impersonating, /me returns isImpersonating=true.
	//	the chat UI shows the impersonated user's name (the connection routes through the
	//	impersonation resolver), so a stripe here calls out the divergence.
	const { session } = useSessionContext()

	const colorSet = getColorSet({ senderColor: user?.color })

	return (
		<div
			className="border-b"
			style={{ borderColor: colorSet.border, backgroundColor: colorSet.background }}
		>
			{session?.isImpersonating && (
				<div
					className="px-3 py-1.5 text-xs font-semibold text-center"
					style={{ backgroundColor: '#b45309', color: '#fff' }}
					data-testid="impersonation-banner"
				>
					Impersonating — actions affect another user. Use <code>!stop-impersonating</code> to end.
				</div>
			)}
			<div className="py-4 px-3 flex flex-row justify-between items-center">
				<div className="flex flex-col flex-1">
					<h1 className="text-lg font-bold" style={{ color: colorSet.dark }}>
						{user ? getUserDisplayName(user) : null}
					</h1>
					{/* <h3 className="text-sm font-semibold" style={{ color: colorSet.dark }}>
						{user?.userId}
					</h3> */}
				</div>
				<button
					onClick={() => navigate('/settings')}
					className="p-2 text-gray-600 hover:text-gray-900"
					title="Settings"
				>
					<Settings className="h-5 w-5" color={colorSet.dark}/>
				</button>
				<button onClick={props.onClose} className="md:hidden p-2">
					<X className="h-5 w-5" color={colorSet.dark}/>
				</button>
			</div>
		</div>
	)
}

export default ChannelsHeader